export default {
    workOrder_historyLogs_createdOn: "Created On",
    workOrder_historyLogs_updatedOn: "Updated On",
    workOrder_historyLogs_scheduledDate: "Scheduled Date",
    workOrder_historyLogs_customer: "Customer",
    workOrder_historyLogs_location: "Location",
    workOrder_historyLogs_contact: "Contact",
    workOrder_historyLogs_driver: "Driver",
    workOrder_historyLogs_estimatedDuration: "Estimated Duration",
    workOrder_historyLogs_severity: "Severity",
    workOrder_historyLogs_status: "Status",
    workOrder_historyLogs_description: "Description",

    workOrder_historyLogs_changeStatus: "Status Changed",
    workOrder_historyLogs_createWorkOrder: "Created Work Order",
    workOrder_historyLogs_updateWorkOrder: "Edited Work Order",
    workOrder_historyLogs_createComment: "Created Comment",
    workOrder_historyLogs_updateComment: "Updated Comment",
    workOrder_historyLogs_deleteComment: "Deleted Comment",
    workOrder_historyLogs_comment: "Comment",
    workOrder_historyLogs_type: "Type",
    workOrder_historyLogs_action: "Action",
    workOrder_historyLogs_arrival: "The Driver arrived at the location",
    workOrder_historyLogs_departure: "The Driver departure at the location",
    workOrder_historyLogs_address: "Address",
    workOrder_historyLogs_gpsEvent: "GPS Event",
    workOrder_historyLogs_locationName: "Location Name",
    workOrder_historyLogs_customerName: "Customer Name",
    workOrder_historyLogs_createdBy: "Created By",
    workOrder_historyLogs_contactName: "Contact Name",
    workOrder_historyLogs_contactEmail: "Contact Email",
    workOrder_historyLogs_contactPhone: "Contact Phone",
    workOrder_historyLogs_address: "Address",
    workOrder_historyLogs_previousStatus: "Previous Status",
    workOrder_historyLogs_newStatus: "New Status",
    workOrder_historyLogs_changes: "Changes",
    workOrder_historyLogs_note: "Note",
    workOrder_historyLogs_completedForm: "Completed Form",
    workOrder_historyLogs_updatedForm: "Updated Form",
};